import React from "react";
import { AppBar, Badge, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CottageOutlinedIcon from '@mui/icons-material/CottageOutlined';
import { Link } from "react-router-dom";

const Navbar = () => {
  const auth = true;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return(
    <>
      <AppBar style={{boxShadow: "none"}} position="static" color="transparent">
        <Toolbar>
          <CottageOutlinedIcon color="primary" sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography color="secondary" variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link to={"/"} style={{textDecoration: "none", color: "inherit"}}>
              NFT Carbon
            </Link>
          </Typography>
          {auth && (
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-user"
                aria-haspopup="true"
                onClick={handleMenu}
                color="secondary"
              >
                <Badge variant="dot" color="danger" invisible={false}>
                  <NotificationsOutlinedIcon color="secondary" />
                </Badge>
              </IconButton>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-user"
                aria-haspopup="true"
                onClick={handleMenu}
                color="secondary"
              >
                <AccountCircleOutlinedIcon />
              </IconButton>
              <Menu
                id="menu-user"
                anchorEl={anchorEl}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>Profile</MenuItem>
                <MenuItem onClick={handleClose}>My account</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Navbar;